//Error Status Code
export const UNAUTHORIZED_ERROR_CODE_401 = 401;
//Error Type
export const ERROR_UNAUTHORIZED = 'Unauthorized';
//Error Message
export const TOKEN_EXPIRED_ERROR = 'TokenExpiredError';

export const SERVER_ERROR =
  'The server encountered an error processing the request. Please try again later.';
